
const findMaterialByTypeId = (materials, materialTypeId) => {
   if(materials !== undefined &&  materials !== null && materials.length > 0)
       return materials.find(material => material.materialTypeId === materialTypeId)
}

export {
   findMaterialByTypeId
}